import * as Sentry from "@sentry/browser";
import {functions} from "hooks/firebase";
import {isNullOrUndefined} from "helpers/is-null-or-undefined";
import {ProductIds, PurchasedProduct} from "data/models/shared/stripe-create-checkout-session";
import {
  StripeGetActiveProductsRequest,
  StripeGetActiveProductsResponse
} from "data/models/shared/stripe-get-active-products";
import {useEffect, useState} from "react";
import {useStripeCustomerId} from "hooks/stripe/useStripeCustomerId";
import {httpsCallable} from "firebase/functions";

export const useActivePurchasedProduct = (productId: ProductIds): [PurchasedProduct | null, boolean, Error | null] => {
  const [stripeCustomerId, , customerIdLoading, customerIdError] = useStripeCustomerId();
  const [purchasedProduct, setPurchasedProduct] = useState<PurchasedProduct | null>(null);
  const [purchasedProductLoading, setPurchasedProductLoading] = useState<boolean>(false);

  useEffect(() => {
    if (isNullOrUndefined(stripeCustomerId)) {
      return;
    }
    setPurchasedProductLoading(true);
    const stripeGetActiveProductsFunction = httpsCallable<StripeGetActiveProductsRequest, StripeGetActiveProductsResponse>(functions, "stripeGetActiveProducts");

    stripeGetActiveProductsFunction({
      customerId: stripeCustomerId,
    }).then(result => {
      if ("error" in result.data) {
        Sentry.captureException(result.data.error);
        setPurchasedProduct(null);
      } else if (result.data.activeProducts.map(({id}) => id).includes(productId)) {
        setPurchasedProduct({
          id: productId,
        })
      }
    }).then(() => setPurchasedProductLoading(false));
  }, [stripeCustomerId]);

  return [
    purchasedProduct,
    purchasedProductLoading || customerIdLoading,
    customerIdError
  ];
}
